import React from 'react';
import Head from 'next/head';
import { Container, Row, Col, Button } from 'reactstrap';
import Page from '../components/page';
import { SiteChrome, SiteData } from '../components/chrome/layout';
import TestimonialPanel from '../components/meetTheOne/matchingCarousel';
import MatchingCauses from '../components/meetTheOne/matchingCause';
import MatchingProcess from '../components/meetTheOne/matchingProcess';
import FAQPaMatching from '../components/meetTheOne/matchingFaq';
import ProgramCard from '../components/chrome/elements/cards/programCard';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const programs = [
	{
 	 cause: 'Education',
 	 location: 'Uttarakhand',
 	 title: 'Sponsor the educational journey of a poor child',
 	 ngo: 'Purkal Youth Development Society',
 	 price: '1335',
 	 image: '/static/images/program/sponsor-the-educational-journey-of-a-poor-child.jpg',
 	 programLink: 'Sponsor-the-educational-journey-of-a-poor-child#',
	},
	{
		cause: 'Education',
		location: 'Tamil Nadu',
		title: 'Educate a poor rural child',
		ngo: 'Isha Education',
		price: 1110,
		image: '/static/images/program/educate-a-poor-rural-child.jpg',
		programLink: 'Educate-a-poor-rural-child#',
	},
	{
		cause: 'Differently Abled',
		location: 'Madurai',
		title: 'Sponsor living expenses of a visually challenged student',
		ngo: 'Indian Association for the Blind',
		price: 1780,
		image: '/static/images/program/sponsor-living-expenses-of-a-visually-challenged-student.jpg',
		programLink: 'Sponsor-living-expenses-of-a-visually-challenged-student#',
	},
];
export default class extends Page {
	constructor(props) {
		super(props);
		this.state = {

		};
	}

	static async getInitialProps({ req, res }) {
		const props = await super.getInitialProps({req, res});
		props.pageType = 'meet-the-one';

		return props;
	}

	render() {
		const { session } = this.props;
		const store = { ... this.props.store };
		return (
			<SiteData store={store}>
				<SiteChrome session={session}>
					<Head>
						<title>Meet the One</title>
						<link rel="canonical" href={this.props.store.canonicalUrl} />
					</Head>
					<div className="outer-volunteering-container container-fluid">
						<div className="hide-for-desktop" >
							<a href="#one-same" onClick={() => {
								if (window.eventDispatcher) {
									window.eventDispatcher.dispatchEvent('mto-meet-mobile-banner', {}, {amplitude: true});
								}
							}}> <img className="volunteering-timeline-img-mobile w-100" src={`${config.cdnUrl}/static/images/meet-your-match/meet-the-one-top-banner-mobile.jpg`} alt="meet the one" /></a>
						</div>
						<Container className="volunteering-container">
							<Col className="volunteering-timeline" sm={12} md={12} lg={12}>
								<div className="hide-for-mobile" >
									<a href="#one-same" onClick={() => {
										if (window.eventDispatcher) {
											window.eventDispatcher.dispatchEvent('mto-meet-desktop-banner', {}, {amplitude: true});
										}
									}}>	<img className=" w-100" src={`${config.cdnUrl}/static/images/meet-your-match/meet-the-one-top-banner-desktop.jpg`} alt="meet the one" /></a>
								</div>
							</Col>
							<MatchingProcess />
							<br />

							<hr className="margin-aboutus" />
							<p className="text-center matching-heading">Giving makes you happy</p>


							<TestimonialPanel />

							<div style={{ paddingTop: '2rem' }} >
								<center><a href="/search?tag=Individual%20Support&type=relevance"><Button color="primary" className=" btn matching-button " type="submit" onClick={() => {
									if (window.eventDispatcher) {
										window.eventDispatcher.dispatchEvent('mto-meet-button', {}, {amplitude: true});
									}
								}} >  Meet The One </Button></a></center>
							</div>
							<hr className="margin-aboutus" />
							<MatchingCauses />
							<hr className="margin-aboutus" />
							<div id="one-same">
								<p className="text-center matching-heading">Programs that can help you meet the one you will support</p>
								<Row className="remove-margin">
									{programs.map((program, index) => (
										<ProgramCard
											type="homePage"
											category="test"
											position={index}
											program={program}
											session={session}
											key={`program-${index}`}
										/>
									))}
								</Row>
								<div style={{ paddingTop: '2rem' }}>
									<center><a href="/search?tag=Individual%20Support&type=relevance"><Button color="primary" className=" btn matching-button " type="submit" onClick={() => {
										if (window.eventDispatcher) {
											window.eventDispatcher.dispatchEvent('mto-meet-programs', {}, {amplitude: true});
										}
									}} >  View all programs </Button></a></center>
								</div>
							</div>
							<hr className="margin-aboutus" />
							<FAQPaMatching />
						</Container>
					</div>
					<style global jsx>
						{
							`
							.margin-aboutus{
								margin-top:55px!important;
								margin-bottom: 55px!important;
												border-top: 1px solid #dddddd !important;
						 }
							.testimonial-carousel {
								box-shadow: 0px 1px 24.03px 2.97px rgba(221, 221, 221, 0.75);
							}
							.guide-arrow {
		align-self: center;
}
@media(max-width: 767px) {
		.guide-arrow {
				transform: rotate(100deg);
				justify-content: center;
	 }
		.guide-steps {
				padding: 0px !important;
	 }

		.matching-program-you-support{
				text-align: center;
				font-size: 25px;
	 }


							`
						}
					</style>
				</SiteChrome>
			</SiteData>
		);
	}
}
